import { ActionType, createAction } from 'typesafe-actions';

export const InitializationActions = {
    initializationSuccess: createAction('initialization/SUCCESS')(),
};

export type InitializationActions = ActionType<typeof InitializationActions>;
